module.exports = __webpack_public_path__ + "static/media/foto12.8bb57bf0.jpg";